import { render, staticRenderFns } from "./python.vue?vue&type=template&id=40c02a45&scoped=true&"
import script from "./python.vue?vue&type=script&lang=js&"
export * from "./python.vue?vue&type=script&lang=js&"
import style0 from "./python.vue?vue&type=style&index=0&id=40c02a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c02a45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c02a45')) {
      api.createRecord('40c02a45', component.options)
    } else {
      api.reload('40c02a45', component.options)
    }
    module.hot.accept("./python.vue?vue&type=template&id=40c02a45&scoped=true&", function () {
      api.rerender('40c02a45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/python/python.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/python/python.vue
// module id = NBJ4
// module chunks = 0